module.exports = __webpack_public_path__ + "img/chat.ead3c05c.svg";